import React from 'react';
import styles from '../static/styles/MessagePopup.module.css';

const CannonClashPopup = ({ isOpen, message, onClose, showCloseButton = true }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContent}>
        <p className={styles.popupMessage}>{message}</p>
        {showCloseButton && (
          <button 
            className={styles.closeButton} 
            onClick={onClose}
          >
            Close
          </button>
        )}
      </div>
    </div>
  );
};

export default CannonClashPopup;